import { Shark } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import "regenerator-runtime/runtime";

import Client from "../models/Client";
import ManagerBase from "./ManagerBase";

class ClientManager extends ManagerBase {
	constructor () {
		super("clientManager");

		this.responsesModelClass = Client;
		this.remoteClassName = "client";
	}

	async getByGuidList (guidList) {
		const rd = NousCore.api.createRequest({ item: { guidList } });

		const result = await this.sendRequest(rd, "get-by-guid-list");
		result.items = result.data.items; // Temporaneo
		return result;

		// const clientList = Shark.getInstanceList(Client, result.data);
		// return {
		// 	data: clientList,
		// 	status: "ok"
		// };
	}

	async getList () {
		const clientListResult = await super.getList();

		clientListResult.data.sort((a, b) => {
			if (a.name.toLowerCase() > b.name.toLowerCase()) {
				return 1;
			}
			else if (a.name.toLowerCase() < b.name.toLowerCase()) {
				return -1;
			}
		});

		Shark.set({
			clientList: clientListResult.data,
		});
		
		return clientListResult;
	}

	save (client) {
		const rd = NousCore.api.createRequest({ item: client.export() });
		const action = client.guid === "" ? "insert" : "update";
	
		return NousCore.api.send(`${this.remoteClassName}/${action}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						if (data.items.length > 0) {
							client.import(data.items[0]);
						}
						return {
							data: client,
							requestedAction: action,
							status: "ok"
						};
				}
			}
		});
	}
}

const clientManager = new ClientManager();

Shark.registerController(clientManager);

export default clientManager;